<template>
    <div class="main">

        <el-form label-position="top">

            <el-tabs type="border-card" v-model="tabAtivo">
                <el-tab-pane label="FILTROS" name="filtros">

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="18" :md="18">
                            <el-form-item label="Instituição" key="instituicao" v-if="$store.state.user.tipo == 10 || ($store.state.user.tipo > 3 && $store.state.user.tipo <= 8)">
                                <el-select @change="getTurmas()" ref="instituicao_id" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                            <div class="style-form" v-if="$store.state.user.tipo <= 3 || $store.state.user.tipo == 9 || $store.state.user.tipo == 12">
                                <label>Instituição</label>
                                <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Período" key="periodo">
                                <el-select @change="getTurmas()" ref="periodo_letivo_id" v-model="filtro.periodo_letivo_id" clearable>
                                    <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Consolidado por" key="consolidado">
                                <el-select ref="consolidado" v-model="filtro.consolidado" @change="filtro.periodo_diario = ''">
                                    <el-option v-for="op in opcoesConsolidado" :key="op.value" :label="op.label" :value="op.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Turma" key="turma">
                                <el-select v-model="filtro.turma_id" @change="changeTurma()" clearable filterable>
                                    <el-option-group
                                        v-for="(grupo, i) in turmas"
                                        :key="i"
                                        :label="i">
                                        <el-option
                                            v-for="turma in grupo"
                                            :key="turma.id"
                                            :label="`${turma.curso.nome} ${turma.nome}`"
                                            :value="turma.id">
                                        </el-option>
                                    </el-option-group>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10" v-if="filtro.consolidado == 'atividades'">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Período do Diário" key="periodo_diario">
                                <el-select ref="periodo_diario" v-model="filtro.periodo_diario" clearable>
                                    <el-option
                                        v-for="(periodo, i) in turmaSelecionada.periodos_diario"
                                        :key="i"
                                        :label="periodo"
                                        :value="i + 1">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Disciplina" key="disciplina">
                                <el-select ref="disciplina" v-model="filtro.disciplina" clearable filterable>
                                    <el-option
                                        v-for="disciplina in turmaSelecionada.disciplinas"
                                        :key="disciplina.id"
                                        :label="disciplina.nome"
                                        :value="disciplina.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-tab-pane>
            </el-tabs>

            <div class="u-mt-10">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <el-button @click="gerarPdf()" :loading="loadingButtonPdf" type="primary">GERAR RELATÓRIO</el-button>
                    </el-col>
                </el-row>
            </div>

        </el-form>

    </div>
</template>
<script>
import cPanel from '../../../shared/c-panel/c-panel.vue';

export default {
    components: { cPanel },
    data: () => ({
        tabAtivo: 'filtros',
        loadingButtonPdf: false,
        filtro: {
            instituicao_id: '',
            periodo_letivo_id: '',
            consolidado: '',
            turma_id: '',
            periodo_diario: '',
            disciplina: ''
        },
        turmas: [],
        turmaSelecionada: {}
    }),
    computed: {
        // No modo média do período (diario.nota_modo = media_periodo) não há atividades: só o consolidado por período.
        opcoesConsolidado () {
            let opcoes = [
                { value: 'atividades', label: 'ATIVIDADES' },
                { value: 'periodo', label: 'PERÍODO' }
            ];
            if(this.$store.state.config.parametros.nota_modo == 'media_periodo'){
                opcoes = opcoes.filter(op => op.value != 'atividades');
            }
            return opcoes;
        }
    },
    mounted () {

        if(this.opcoesConsolidado.length == 1){
            this.filtro.consolidado = this.opcoesConsolidado[0].value;
        }

        this.filtro.periodo_letivo_id = this.$store.state.config.parametros.periodo_letivo_situacao_academica;

        if(this.$store.state.user.tipo <= 3 || this.$store.state.user.tipo == 9 || this.$store.state.user.tipo == 12) {
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
        }

        this.getTurmas();
    },
    methods: {

        getTurmas(){

            this.filtro.turma_id = '';
            this.turmaSelecionada = {};

            if(!this.filtro.instituicao_id || !this.filtro.periodo_letivo_id){
                this.turmas = [];
                return false;
            }

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/${this.filtro.instituicao_id}/${this.filtro.periodo_letivo_id}`, this.$store.getters.getHeaderAuth).then(response => {

                this.turmas = response.data;

            }).catch((error) => { this.$store.commit('throwException', error); });
        },

        changeTurma(){

            this.filtro.periodo_diario = '';
            this.filtro.disciplina = '';
            this.turmaSelecionada = {};

            for(let grupo in this.turmas){
                for(let t of this.turmas[grupo]){
                    if(t.id == this.filtro.turma_id){
                        this.turmaSelecionada = t;
                        return;
                    }
                }
            }
        },

        gerarPdf(){

            if(!this.filtro.consolidado){
                window.eventBus.$emit('alert', {msg: 'Selecione o tipo de consolidação (Atividades ou Período).', type: 'warning'});
                return;
            }
            if(!this.filtro.turma_id){
                window.eventBus.$emit('alert', {msg: 'Selecione a turma.', type: 'warning'});
                return;
            }
            if(this.filtro.consolidado == 'atividades' && !this.filtro.periodo_diario){
                window.eventBus.$emit('alert', {msg: 'Selecione o período do diário.', type: 'warning'});
                return;
            }
            if(!this.filtro.disciplina){
                window.eventBus.$emit('alert', {msg: 'Selecione a disciplina.', type: 'warning'});
                return;
            }

            this.loadingButtonPdf = true;

            let payload = {
                turma_id: this.filtro.turma_id,
                periodo_diario: this.filtro.periodo_diario,
                disciplina: this.filtro.disciplina,
                consolidado: this.filtro.consolidado
            };

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioDiarioNota`, payload, this.$store.getters.getHeaderAuthExcel).then(response => {

                this.loadingButtonPdf = false;

                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const novaAba = window.open(url, '_blank');
                if(!novaAba){ window.location.href = url; }

            }).catch((error) => { this.loadingButtonPdf = false; window.eventBus.$emit('alert', {msg: 'Erro ao gerar o relatório.', type: 'warning'}); this.$store.commit('throwException', error); });
        }
    }
}
</script>
